<template>
  <div class="bo_cont">
    <div class="cont">
      <div class="cont_bot">
        <div class="bot_con">
          <div class="bot_left font_size3">
            <a href="https://beian.miit.gov.cn/" style="color: white;">滇ICP备17008416号-4</a>
          </div>
          <div class="bot_right font_size2">
            <router-link to="/" class="bot_right_con" :class="{ 'active': $route.path === '/' }">首页</router-link>
            <router-link to="/Product" class="bot_right_con"
              :class="{ 'active': $route.path === '/Product' }">产品列表</router-link>
            <router-link to="/AboutUs" class="bot_right_con"
              :class="{ 'active': $route.path === '/AboutUs' }">关于我们</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  created () { },
  watch: {},
  methods: {
    tohome (page, url) {
      this.$router.push({ path: url, query: { page: page, time: Date.now() } });
    },
  },
};
</script>

<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
@mixin w_h {
  height: 100%;
  width: 100%;
}

.bo_cont {
  @include w_h;
  background-color: #000000;

  .cont {
    height: 100%;
  }
}

.cont_top {
  width: 70%;
  margin: 0px auto;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e9f5ff;

  .top_left {
    flex-basis: 0;
    flex-grow: 1;
    @include w_h;

    .top_left_top {
      height: 80%;
      display: flex;
      align-items: center;
      text-align: center;

      .top_img {
        width: 82px;
        height: 82px;
      }
    }

    .top_left_bot {
      height: 20%;
    }
  }

  .top_right {
    flex-basis: 0;
    flex-grow: 1;
    display: flex;
    justify-content: center;

    .bot_row {
      flex-basis: 0;
      flex-grow: 1;

      .row_tit::after {
        content: "";
        float: left;
        margin: 4px;
        line-height: 18px;
        width: 1px;
        height: 18px;
        background: #e9f5ff;
      }
    }
  }
}

.cont_bot {
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #1e3555;

  .bot_con {
    width: 70%;
    margin: 0px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #c4c4c4;

    .bot_left {
      flex-grow: 1;
      flex-basis: 0;
      display: flex;
      align-items: center;
    }

    .bot_right {
      flex-grow: 1;
      flex-basis: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .bot_right_con {
        margin-left: 27px;
        color: white;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        padding: 5px 0;
        position: relative;
        transition: all 0.3s ease;
      }

      .bot_right_con::after {
        content: "";
        float: left;
        margin: 4px;
        line-height: 18px;
        width: 1px;
        height: 18px;
        background: #c4c4c4;
      }
    }
  }
}

.font_size1 {
  font-size: 18px;
}

.font_size2 {
  font-size: 16px;
}

.font_size3 {
  font-size: 14px;
}

@media screen and (min-width: 1440px) and (max-width: 1600px) {
  .font_size1 {
    font-size: 16px !important;
  }

  .font_size2 {
    font-size: 14px !important;
  }

  .font_size3 {
    font-size: 12px !important;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1440px) {
  .font_size1 {
    font-size: 14px !important;
  }

  .font_size2 {
    font-size: 12px !important;
  }

  .font_size3 {
    font-size: 10px !important;
  }
}

/* 仅添加的手机端适配样式 */
@media screen and (max-width: 767px) {
  .cont_bot {
    padding: 10px 0;

    .bot_con {
      width: 90%;
      flex-wrap: wrap;

      .bot_left {
        justify-content: center;
        flex-basis: 100%;
        text-align: center;
      }

      .bot_right {
        flex-basis: 100%;
        justify-content: space-around;
        flex-wrap: wrap;

        .bot_right_con {
          margin: 0 5px;
          font-size: 14px;
          padding: 8px 0;

          &::after {
            display: none;
          }
        }
      }
    }
  }

  .font_size3 {
    font-size: 12px !important;
  }
}

/* 小尺寸手机优化 */
@media screen and (max-width: 480px) {
  .cont_bot .bot_con .bot_right .bot_right_con {
    font-size: 13px;
    padding: 6px 0;
  }

  .font_size3 {
    font-size: 11px !important;
  }
}
</style>